<template>
  <div class="modal fade" id="createCategoryModal" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="createCategoryData" enctype="multipart/form-data" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('button.add') }}</h5>

            <!--begin::Close-->
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
              <!--begin::Svg Icon | path: icons/duotune/arrows/arr061.svg-->
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                    fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                    fill="currentColor" />
                </svg>
              </span>
              <!--end::Svg Icon-->
            </div>

            <!--end::Close-->
          </div>
          <div class="modal-body">
            <div class="d-flex flex-column mb-8 fv-row">
              <!--begin::Label-->
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required">{{ $t('category.name') }}</span>
              </label>
              <!--end::Label-->
              <input type="text" class="form-control form-control-solid" v-model="formCreateData.name"
                :placeholder="$t('category.name_placeholder')" required />
            </div>
            <div class="d-flex flex-column mb-8 fv-row">
              <!--begin::Label-->
              <!-- Parent obligatoire : un article se rattache à une sous-catégorie, jamais à une
                   catégorie parente — la catégorie créée ici doit donc avoir un parent. -->
              <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                <span class="required">{{ $t('category.parent') }}</span>
              </label>
              <!--end::Label-->
              <!-- même groupe « sélecteur + » que le choix de catégorie de la fiche article -->
              <div class="input-group input-group-solid flex-nowrap">
                <div class="overflow-hidden flex-grow-1">
                  <select class="form-select form-select-solid kt_select2" data-control="select2" name="categories[]"
                    id="kt_select3" v-model="formCreateData.categories" :data-placeholder="$t('category.parent_placeholder')"
                    data-allow-clear="true" multiple="multiple">
                    <option></option>
                    <option v-for="category in getCategories" :key="category.id" :value="category.id">{{ category.name }}
                    </option>
                  </select>
                </div>
                <!-- « + » : créer une nouvelle catégorie parente sans quitter la fenêtre -->
                <span class="input-group-text" role="button" :title="$t('category.new_parent')" @click="showNewParent = !showNewParent"><i class="bi bi-plus fs-4"></i></span>
              </div>
              <div class="d-flex align-items-center mt-3" v-if="showNewParent">
                <input type="text" class="form-control form-control-solid form-control-sm" v-model="newParentName"
                  :placeholder="$t('category.new_parent_placeholder')" @keydown.enter.prevent="createParentCategory" />
                <button type="button" class="btn btn-sm btn-primary ms-2 flex-shrink-0"
                  :disabled="isCreatingParent || !newParentName.trim()" @click="createParentCategory">
                  <span v-if="isCreatingParent" class="spinner-border spinner-border-sm align-middle"></span>
                  <span v-else>{{ $t('button.add') }}</span>
                </button>
              </div>

            </div>
            <!--begin::Image input-->
            <div style="margin-top:40px; text-align:center">
              <div class="image-input image-input-outline" data-kt-image-input="true" :style="{backgroundImage: 'url(' + formCreateImage +')'}">
                <div class="image-input-wrapper w-125px h-125px" :style="{backgroundImage: 'url(' + formCreateImage +')'}"></div>
                <label class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="Change avatar">
                  <i class="bi bi-pencil-fill fs-7"></i>
                  <input v-on:change="onFileChange" type="file" name="image" accept=".png, .jpg, .jpeg" />
                  <input type="hidden" name="avatar_remove" />
                </label>
                <!-- <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="cancel" data-bs-toggle="tooltip" title="Cancel avatar">
                    <i class="bi bi-x fs-2"></i>
                </span> -->
                <span class="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                      v-on:click="removeImageFile" title="Remove avatar">
                                        <i class="bi bi-x fs-2"></i>
                                    </span>
              </div>
            </div>
            <!--end::Image input-->
            <div class="mb-1">
              <div class="form-check form-check-custom form-check-solid">
                <input class="form-check-input" type="checkbox" v-model="formCreateData.online" id="flexCheckChecked"
                  checked="checked" />
                <label class="form-check-label" for="flexCheckChecked">{{ $t('category.put_online') }}</label>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
            <button type="submit" id="kt_submit_create_category" class="btn btn-sm btn-primary fw-bolder">
              <span class="indicator-label">{{ $t('button.save') }}</span>
              <span class="indicator-progress">{{ $t('loading') }}
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span></span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { brandedPlaceholder } from '@/composables/useBranding'
import {BASE_IMAGE_URL, BASE_URL} from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import CreateCategory from "@/components/Category/CreateCategory";
import {nextTick} from "vue";

export default {
  name: "CreateCategory",
  data() {
    return {

      formCreateData: {
        name: '',
        image: null,
        categories: [],
        online: true,
      },
      image: '',
      table: null,
      imagePreview: null,
      // création rapide d'une catégorie parente depuis le bouton « + » du sélecteur
      showNewParent: false,
      newParentName: '',
      isCreatingParent: false,
    }
  },

  computed: {
    ...mapGetters('categories', [
      'getCategories'
    ]),
    // Image par défaut des catégories : la même que celle de la liste (servie par l'API).
    // Un fichier choisi (File) est prévisualisé par KTImageInput.
    formCreateImage(){
      return typeof this.formCreateData.image === 'string' && this.formCreateData.image
          ? this.formCreateData.image : brandedPlaceholder('category')
    }
  },

  watch: {
    'formCreateData.image': async function (value) {
      this.$nextTick(() => {
        KTImageInput.init();
      })
    },
    '$i18n.locale': function (value) {
      // Le placeholder select2 ("Catégorie parente") est lu une seule fois
      // à l'initialisation depuis data-placeholder — on détruit/réinitialise
      // pour qu'il relise l'attribut (mis à jour par Vue) dans la nouvelle langue.
      if (value) {
        this.$nextTick(() => {
          $('.kt_select2').each(function () {
            if ($(this).hasClass('select2-hidden-accessible')) {
              $(this).select2('destroy')
            }
          })
          $('.kt_select2').select2()
        })
      }
    }
  },

  async mounted() {
    this.loadCategories()
    $(".kt_select2").select2()
    $("#createCategoryModal").on("shown.bs.modal", function () {
      $('.kt_select2').select2().select2();
    }),
    $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'categories[]':
            let categories = [];
            for (var k = 0, kLen = e.target.selectedOptions.length; k < kLen; k++) {
              if (e.target.selectedOptions[k].value != '' || e.target.selectedOptions[k].value != undefined) {
                categories.push(e.target.selectedOptions[k].value);
              }
            }
            this.formCreateData.categories = categories
            break;
          default:
            break;

        }
      });

  },

  methods: {
    ...mapActions('categories', [
      'createCategory',
      'loadCategories'
    ]),

    openCreateModal() {
      $('#createCategoryModal').modal('toggle')
    },
    // Bouton « + » du sélecteur : crée une catégorie parente (sans parent ni image) et la
    // sélectionne aussitôt comme parent de la catégorie en cours de saisie.
    async createParentCategory() {
      const name = this.newParentName.trim()
      if (!name || this.isCreatingParent) return
      this.isCreatingParent = true
      try {
        const response = await this.createCategory({ name, image: null, online: true, categories: [] })
        const selected = [...(this.formCreateData.categories || []), response.data.category.id]
        this.formCreateData.categories = selected
        this.newParentName = ''
        this.showNewParent = false
        // select2 ne voit la nouvelle <option> qu'une fois rendue par Vue
        this.$nextTick(() => $('#kt_select3').val(selected).trigger('change'))
        window.toastr['success'](i18n.global.t('notification.category'))
      } catch (err) {
        // le message d'erreur (doublon, limite…) est déjà affiché par l'intercepteur global
      } finally {
        this.isCreatingParent = false
      }
    },

    async createCategoryData() {
      if (!this.formCreateData.categories || !this.formCreateData.categories.length) {
        window.toastr['error'](i18n.global.t('category.parent_required'))
        return false
      }

      this.$loading('kt_submit_create_category')

      try {
        let response = await this.createCategory(this.formCreateData)
        // On recharge l'arborescence avant de prévenir la fiche article : son sélecteur
        // liste les sous-catégories sous leur parent, la nouvelle doit y figurer.
        try { await this.loadCategories() } catch (e) { /* la liste se rechargera plus tard */ }
        this.$emit('loadCategory', response.data.category)

        $('#createCategoryModal').modal('toggle')
        window.toastr['success'](i18n.global.t('notification.category'))
        this.formCreateData = {
          name: '',
          categories: [],
          online: '',
          image: '',
        }
        this.showNewParent = false
        this.newParentName = ''
        $('#kt_select3').val([]).trigger('change')

        this.$stopLoading('kt_submit_create_category')

        return true
      } catch (err) {
        this.$stopLoading('kt_submit_create_category')
      }
    },

    onFileChange(event) {
      this.formCreateData.image = event.target.files[0];
    },

    removeImageFile(e) {
      this.formCreateData.image = null

    },



  }
}
</script>
<style scoped>
/* Aperçu de l'image : recadrage centré (le thème cadre en haut à gauche) */
.image-input,
.image-input .image-input-wrapper {
  background-position: center;
  background-repeat: no-repeat;
}
</style>
